/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit MaybeRedirectToInstall/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function MaybeRedirectToInstall({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/Apps/Content/App/MaybeRedirectToInstall"
  
}) {
  return null
}